import styled from "styled-components";

export const LinkedPlanStyled = styled.div`
  .no-data-message {
    display: grid;
    align-content: center;
    justify-content: center;
    gap: 16px;
    text-align: center;
  }
  td:nth-last-child(1) {
    padding: 0 !important;
  }

  .no-data .create-cta {
    justify-content: center;
  }
`;
